<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col">
        <!-- En-tête + CTA sur fond dégradé -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="px-2 py-3">
                <app-header icon="tools" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">Contrôles d'étanchéité</h1>
                    </div>
                </app-header>
                <!-- Action principale (garde id=main-action pour le JS) -->
                <action-bar :back="{ name: 'home' }" class="pb-5 mb-2">
                    <button
                        class="btn inline-flex items-center gap-2 bg-white text-alert text-sm font-semibold px-4 py-2 rounded-lg shadow-sm hover:shadow transition"
                        @click="resetValues(true)">
                        <i class="inline-block h-6 w-6 mask mask-trash bg-alert"></i>
                        <span>Tout effacer</span>
                    </button>
                </action-bar>
            </div>
        </div>

        <!-- Corps -->
        <div
            class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
            <div class="wrap m-2 sm:m-4">
                <form id="ctrl-multi" class="bg-white rounded-xl shadow-2xl p-4 sm:p-6 space-y-5 w-full max-w-full">

                    <!-- RÉFÉRENCE -->
                    <div>
                        <h2 class="label">
                            RÉFÉRENCE BON ET / OU NOM TECHNICIEN
                        </h2>
                        <input title="ref" type="text" name="ordre" maxlength="100" v-model="ordreTravail"
                            @change="changeValue('ordreTravail')" class="input" placeholder="Ex. BT-1234 — Dupont" />
                    </div>

                    <!-- Intervention contractuelle -->
                    <div class="check">
                        <input type="checkbox" id="contract" v-model="contractuel" @change="changeValue('contractuel')"
                            class="peer hidden" />
                        <label for="contract"
                            class="btn check cursor-pointer block text-left border border-gray-300 text-gray-700 px-3 py-3 rounded-md transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                            Intervention contractuelle
                            <i class="inline-block h-6 w-6 mask mask-check-circle text-white"></i>
                        </label>
                    </div>

                    <!-- DÉTENTEUR -->
                    <div>
                        <h2 class="label">
                            DÉTENTEUR <span class="text-alert">*</span>
                        </h2>
                        <v-select id="id-detenteur" :filterable="false" :on-change="loadInstall"
                            :options="detenteursFiltred" @search="onSearch" class="w-full" />
                    </div>

                    <!-- INSTALLATIONS -->
                    <div class="installations">
                        <h2 class="label">
                            INSTALLATIONS CONTROLÉES <span class="text-alert">*</span>
                        </h2>

                        <!-- Bouton Scan (garde .btn et .hide pour le JS) -->
                        <button
                            class="btn hide inline-flex items-center justify-center px-3 py-3 rounded-lg text-white shadow bg-[#EA5E0B] hover:opacity-95 transition"
                            @click.prevent="scanOtag">
                            Scan Otag Install
                        </button>
                    </div>

                    <!-- Liste installations -->
                    <div class="space-y-2">
                        <div class="checkfull relative" v-for="i in installations" :key="i.id">
                            <input title="install" type="checkbox" :id="'modification-' + i.id" :value="i.id"
                                @change="checkInstall" :disabled="installSelected.indexOf(i) === -1 && locked === true"
                                class="peer hidden" />
                            <label
                                class="btn check cursor-pointer block border border-gray-300 text-gray-700 px-3 py-3 rounded-lg pr-12 transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success"
                                :for="'modification-' + i.id">
                                <!-- pastille -->
                                <div v-if="displayPastille(i) === true"
                                    class="absolute left-2 top-1/2 -translate-y-1/2 h-2.5 w-2.5 bg-success rounded-full">
                                </div>

                                <span class="pl-4">
                                    {{ i.nom }}
                                    {{ (i.marque) ? ' - ' + i.marque : '' }}
                                    {{ (i.modele) ? ' - ' + i.modele : '' }}
                                </span>

                                <span v-if="i.fluide !== null && i.fluide.type === 'HFO'"
                                    class="HFO-logo absolute right-12 top-1/2 -translate-y-1/2 bg-white text-black border border-green-800 rounded px-1.5 py-0.5 text-xs">HFO</span>

                                <i class="icon-valid"></i>
                            </label>
                        </div>
                    </div>

                    <!-- Bloc conditionnel (après sélection install) -->
                    <div v-show="installSelected.length !== 0" ref="validation" class="pt-2 space-y-4">
                        <!-- Contrôle d'étanchéité -->
                        <div>
                            <h2 class="label">
                                CONTRÔLE D'ÉTANCHÉITÉ <span class="text-alert">*</span>
                            </h2>
                            <div class="checkfull relative">
                                <input type="checkbox" id="nofuite" value="1" v-model="noFuite"
                                    @change="changeValue('noFuite')" class="peer hidden" />
                                <label for="nofuite"
                                    class="btn check blue cursor-pointer block text-left border border-gray-300 text-gray-700 px-3 py-3 rounded-lg transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                                    Aucune fuite constatée
                                    <i class="icon-valid"></i>
                                </label>
                            </div>
                        </div>

                        <!-- Entretien-contrôle -->
                        <div>
                            <h2 class="label">
                                ENTRETIEN-CONTRÔLE
                            </h2>
                            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <div class="checkfull relative">
                                    <input type="checkbox" id="nettoyage" value="1" v-model="nettoyage"
                                        @change="changeValue('nettoyage')" class="peer hidden" />
                                    <label for="nettoyage"
                                        class="btn check blue cursor-pointer block text-left border border-gray-300 text-gray-700 px-3 py-3 rounded-lg transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                                        Nettoyage de base réalisé
                                        <i class="icon-valid"></i>
                                    </label>
                                </div>

                                <div class="checkfull relative">
                                    <input type="checkbox" id="ctrlFonctionnement" value="1"
                                        v-model="ctrlFonctionnement" @change="changeValue('ctrlFonctionnement')"
                                        class="peer hidden" />
                                    <label for="ctrlFonctionnement"
                                        class="btn check blue cursor-pointer block text-left border border-gray-300 text-gray-700 px-3 py-3 rounded-lg transition-colors duration-200 peer-checked:bg-success peer-checked:text-white peer-checked:border-success">
                                        Contrôle de bon fonctionnement réalisé
                                        <i class="icon-valid"></i>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Signature -->
                        <div class="space-y-4">
                            <h2 class="text-lg font-medium mb-4 uppercase text-secondary">
                                SIGNATURE
                            </h2>

                            <label class="label">Nom signataire <span class="text-alert">*</span></label>
                            <input title="signName" v-model="nomSignataire" @change="changeValue('nomSignataire')"
                                type="text" name="nom_acquereur" required maxlength="255" class="input"
                                placeholder="Nom et prénom" />

                            <label class="label">Fonction signataire <span class="text-alert">*</span></label>
                            <input title="signFunction" v-model="fonctionSignataire"
                                @change="changeValue('fonctionSignataire')" type="text" name="nom_acquereur" required
                                maxlength="255" class="input" placeholder="Fonction" />

                            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6 w-full">
                                <a class="btn add btn-full inline-flex items-center justify-center gap-3 rounded-lg px-3 py-3 font-semibold transition shadow block !w-full !mx-0"
                                    id="main-action"
                                    :class="interventionIsOk ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-500 cursor-not-allowed'"
                                    :aria-disabled="!interventionIsOk" href="javascript:void(0)"
                                    @click.prevent="triggerSignature">
                                    <i class="inline-block h-6 w-6 mask mask-sign"
                                        :class="interventionIsOk ? 'bg-white' : 'bg-gray-500'"></i>
                                    <strong>Signer et Clôturer les fiches</strong>
                                </a>

                                <a class="btn add btn-full cloturer inline-flex items-center justify-center gap-3 rounded-lg px-3 py-3 font-semibold transition shadow block !w-full !mx-0"
                                    :class="interventionIsOkWithNoSignature ? 'bg-success text-white' : 'bg-gray-200 text-gray-500 cursor-not-allowed'"
                                    :aria-disabled="!interventionIsOkWithNoSignature" href="javascript:void(0)"
                                    @click.prevent="triggerSignatureWithNoSignature" id="clotureWithoutSignature"
                                    :style="interventionIsOkWithNoSignature ? 'background-color: #86bc24' : ''">
                                    <i class="inline-block h-6 w-6 mask mask-close-circle"
                                        :class="interventionIsOkWithNoSignature ? 'bg-white' : 'bg-gray-500'"></i>
                                    <strong>Clôturer les fiches détenteur absent</strong>
                                </a>
                            </div>


                            <!-- Modal signature (inchangé) -->
                            <signature-modal v-show="showModal" :signature="signatureSignataire" :clearOnClose="true"
                                @signatureUpdated="updateSignature" @close="showModal = false" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </main-layout>
</template>


<style scoped>
/* Garde ces classes pour compat JS et micro-styles */
.hide {
    display: none;
}

/* Badge HFO : conservé (on le complète aussi avec des classes Tailwind inline) */
.HFO-logo {
    border-radius: 6px;
}

/* Icône de validation dans les labels (position identique aux anciens styles) */
.check label i,
div.checkfull label.btn.check i {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.8rem;
    color: inherit;
}

/* Fallback pour l’état disabled du bouton principal (classe déjà ajoutée par :class) */
#main-action.disabled {
    background-color: #e2e2e2;
    color: #999;
    font-style: italic;
}
</style>


<script>

    import $ from 'jquery'
    import Detenteur from '../../../js/models/Detenteur'
    import Installation from '../../../js/models/Installation'
    import Outil from '../../../js/models/Outil'
    import Fibsdd from '../../../js/models/Fibsdd'
    import SignatureModal from '../../common/SignatureModal.vue'
    import Offline from '../../../js/models/Offline'

    import vSelect from 'vue-select'

    export default {

        data() {
            return {
                detenteursOpt: [],
                detenteursFiltred: [],
                installations: [],

                installSelected: [],
                detenteurSelected: null,
                ordreTravail: null,
                contractuel: false,
                noFuite: false,
                nettoyage: false,
                ctrlFonctionnement: false,
                nomSignataire: null,
                fonctionSignataire: null,
                signatureSignataire: null,
                detecteur: null,
                locked: false,

                showModal: false,
                localStorage: 'listCtrlMulti'
            }
        },

        computed: {

            interventionIsOk(){
                return (
                    this.detenteurSelected &&
                    this.nomSignataire &&
                    this.fonctionSignataire &&
                    this.installSelected.length !== 0 &&
                    this.noFuite &&
                    this.detecteur
                );
            },

            interventionIsOkWithNoSignature() {
                return (
                    this.detenteurSelected &&
                    this.installSelected.length > 0 &&
                    this.noFuite &&
                    this.detecteur && (this.nomSignataire === "" || this.fonctionSignataire === "")
                )
            }

        },

        methods: {
            scanOtag() {
                if (typeof window.flutter_inappwebview !== 'undefined') {
                    window.flutter_inappwebview.callHandler('scanOtag');
                }
            },
            getInstallation(result) {
                let otag = null;

                if(result.indexOf('#install') > 0) {
                    otag = result.split('#install')[1];
                } else if(result.indexOf('://installation/') > 0) {
                    otag = result.split('/installation/')[1];
                } else if(result.indexOf('bouteille.php#id') > 0 || result.indexOf('://bouteille/') > 0) {
                    swal.close();
                    swal({
                        title: 'Oops',
                        text: "Vous avez scanné une puce O-TAG bouteille, veuillez utiliser une puce O-TAG Install",
                        type: 'warning',
                    })
                    return;
                }

                if (otag != null) {
                    this.selectInstallation(otag);
                }
            },
            selectInstallation(otag) {
                let install = _.find(this.installations, i => i.i_tag == otag);

                if (install) {
                    let input = $(`#modification-${install.id}`);

                    if(input.prop('checked') === false) {
                        input.prop('checked', true);
                        this.checkInstall({target: {checked: true, value: install.id}});
                    } else {
                        input.prop('checked', false);
                        this.checkInstall({target: {checked: false, value: install.id}});
                    }
                } else {
                    swal({
                        title: 'Installation non trouvée',
                        text: "L'installation n'a pas été trouvée",
                        type: 'error',
                    })
                }
            },
            resetValues(all = false) {
                    this.installSelected = [];
                    this.noFuite = false;
                    this.nettoyage = false;
                    this.ctrlFonctionnement = false;
                    this.nomSignataire = null;
                    this.fonctionSignataire = null;
                    this.signatureSignataire = null;
                    this.locked = false;
                    if(all === true){
                        localStorage.removeItem(this.localStorage);
                        localStorage.setItem(this.localStorage, JSON.stringify({}));
                        this.ordreTravail = null;
                        this.contractuel = false;
                        this.checkInstallationWithLocalStorage();
                        $('.selected-tag').remove();
                        $('.checkfull').remove();
                        this.$forceUpdate();
                        let btnScanOtag = document.querySelector('.installations .btn');
                        btnScanOtag.classList.add('hide');
                        window.wantReload();
                    }
            },

            changeValue(key) {
                if(key === 'noFuite'){
                    this.updateLocalStorage('noFuite', this.noFuite);
                }else if(key === "nettoyage") {
                    this.updateLocalStorage('nettoyage', this.nettoyage);
                }else if(key === "ctrlFonctionnement") {
                    this.updateLocalStorage('ctrlFonctionnement', this.ctrlFonctionnement);
                }else if(key === "ordreTravail") {
                    this.updateLocalStorage('ordreTravail', this.ordreTravail);
                }else if(key === "contractuel") {
                    this.updateLocalStorage('contractuel', this.contractuel);
                }else if(key === "nomSignataire") {
                    this.updateLocalStorage('nomSignataire', this.nomSignataire);
                }else if(key === "fonctionSignataire") {
                    this.updateLocalStorage('fonctionSignataire', this.fonctionSignataire);
                }
            },

            displayPastille(install) {

                if(install.fluide) {
                    if(install.fluide.type === "HCFC" && install.charge >= 2) {
                        return true;
                    }

                    if(install.fluide.type === "HFC" && install.tonnage >= 5) {
                        return true;
                    }

                    if(install.charge >= 1) {
                        return true;
                    }
                }

                return false;
            },

            cleanChampDetenteur(det) {

                if($('#id-detenteur').find('.vs__selected-options > span').length > 1){
                    $('#id-detenteur').find('.vs__selected-options > span:first').remove();
                }

                if($('#id-detenteur').find('.vs__selected-options > span').length === 0){
                    $('#id-detenteur').find('.vs__selected-options').prepend('<span class="selected-tag">' + det.label + ' <!----></span>');
                }
            },

            async checkInstallationWithLocalStorage() {

                let installSelected = this.installSelected;

                $.each($('.checkfull > input[id^=modification]'), function (d, v) {

                    //v.value // Value du input
                    if(installSelected.filter(i => i.id == v.value).length > 0){
                        $(v).prop('checked', true);
                    }else{
                        $(v).prop('checked', false);
                    }

                })
            },

            updateLocalStorage(type, val) {

                let localStorageCtrlMulti = localStorage.getItem(this.localStorage);
                let localStorageCtrlMultiObj = JSON.parse(localStorageCtrlMulti);
                localStorageCtrlMultiObj[type] = val;

                localStorage.setItem(this.localStorage, JSON.stringify(localStorageCtrlMultiObj));

            },

            async updatePage() {
                let localStorageCtrlMulti = localStorage.getItem(this.localStorage);
                let localStorageCtrlMultiObj = JSON.parse(localStorageCtrlMulti);

                if(localStorageCtrlMultiObj.hasOwnProperty('detenteurSelected') && localStorageCtrlMultiObj.detenteurSelected != null){
                    this.detenteurSelected = localStorageCtrlMultiObj.detenteurSelected;

                    let det = await Detenteur.getDetenteur(this.detenteurSelected);
                    let cc = (det.code_client) ? ` (${det.code_client})` : '';

                    $('#id-detenteur').find('.vs__selected-options').prepend('<span class="selected-tag"> ' + det.raison_sociale + cc + ' - ' + det.ville + ' / '+ det.code_postal + ' <!----></span>');

                    await this.loadInstall({'label' : det.raison_sociale + cc + ' - ' + det.ville + ' / '+ det.code_postal, 'value' : det.id});

                }

                if(localStorageCtrlMultiObj.hasOwnProperty('installSelected')){
                    this.installSelected = localStorageCtrlMultiObj.installSelected;

                    await this.checkInstallationWithLocalStorage();
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('noFuite')){
                    this.noFuite = localStorageCtrlMultiObj.noFuite;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('nettoyage')){
                    this.nettoyage = localStorageCtrlMultiObj.nettoyage;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('ctrlFonctionnement')){
                    this.ctrlFonctionnement = localStorageCtrlMultiObj.ctrlFonctionnement;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('ordreTravail')){
                    this.ordreTravail = localStorageCtrlMultiObj.ordreTravail;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('contractuel')){
                    this.contractuel = localStorageCtrlMultiObj.contractuel;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('nomSignataire')){
                    this.nomSignataire = localStorageCtrlMultiObj.nomSignataire;
                }

                if(localStorageCtrlMultiObj.hasOwnProperty('fonctionSignataire')){
                    this.fonctionSignataire = localStorageCtrlMultiObj.fonctionSignataire;
                }
            },

            triggerSignature(){
                if(this.interventionIsOk){
                    this.showModal = true
                } else {
                    swal({
                        title: 'Contrôle incomplet',
                        text: 'Veuillez compléter la fiche',
                        type: 'warning'
                    })
                }
            },

            triggerSignatureWithNoSignature() {
                if(this.interventionIsOkWithNoSignature){
                    this.preSendForm();
                } else {
                    swal({
                        title: 'Contrôle incomplet',
                        text: 'Veuillez compléter la fiche',
                        type: 'warning'
                    })
                }
            },

            async createFiches(mail){
                let fiObj = new Fibsdd();
                let i = 1;
                let timestamp = '' + +new Date();
                timestamp = timestamp.slice(0, -3);

                for(let install of this.installSelected){

                    let num = timestamp + '-' + i;
                    i++;
                    let payload = {};

                    payload.numero = num;
                    payload.ordre_travail = this.ordreTravail;
                    payload.detenteur = this.detenteurSelected;
                    payload.installation = install.id;
                    payload.charge_init = install.charge;
                    payload.fluide_init = install.fluide.id;
                    payload.detecteur = this.detecteur;
                    payload.cloture = true;
                    payload.cloturedAt = moment().format('YYYY-MM-DD HH:mm:ss');

                    payload.natures = {};
                    payload.natures.assemblage =  false;
                    payload.natures.miseEnService =  false;
                    payload.natures.modification =  false;
                    payload.natures.maintenance =  false;
                    payload.natures.controlePeriodique =  true;
                    payload.natures.controleNonPeriodique =  false;
                    payload.natures.demantelement =  false;
                    payload.natures.retrofit =  false;
                    payload.natures.newFluide =  null;
                    payload.natures.autres =  null;
                    payload.natures.observations =  null;
                    payload.natures.description =  null;
                    payload.natures.contractuel =  this.contractuel;

                    payload.ctrlEtanch = {};
                    payload.ctrlEtanch.no_fuites = true;

                    payload.infosDet = {};
                    payload.infosDet.nom_signataire = this.nomSignataire;
                    payload.infosDet.fonction_signataire = this.fonctionSignataire;
                    payload.infosDet.signature_signataire64 = this.signatureSignataire;
                    payload.multiCtrl = true;
                    payload.nettoyage = this.nettoyage;
                    payload.ctrlFonctionnement = this.ctrlFonctionnement;

                    let newId = await fiObj.addOfflineFibsdd(payload);

                    await Offline.saveAction({
                        action: 'add',
                        type: 'clotureFibsdd',
                        sendMail: mail,
                        detenteur: this.detenteurSelected,
                        idFi: newId
                    })

                    localStorage.removeItem('listCtrlMulti');

                }

                swal('Contrôles terminés', "Vos contrôles d'étanchéité sont cloturés", 'success').then(() => {
                    this.$router.push('home')
                })

            },

            async preSendForm() {

                let det = await Detenteur.getDetenteur(this.detenteurSelected);

                if(det.email) {

                    swal({
                        title: 'Envoi du rapport',
                        text: "Voulez vous envoyer la fiche d'intervention au détenteur ?",
                        type: 'question',
                        showConfirmButton: true,
                        confirmButtonText: 'Oui',
                        showCancelButton: true,
                        cancelButtonText: 'Non'
                    }).then(
                        () => {
                            this.createFiches(true)
                        }
                        ,
                        () => {
                            this.createFiches(false)
                        }
                    )

                } else {

                    this.createFiches(false)

                }


            },

            async fetchDetenteurs() {

                let dets = _.sortBy(await Detenteur.getList(), det => det.raison_sociale.toUpperCase());
                this.detenteursOpt = dets.map( det => {
                    let cc = (det.code_client) ? ` (${det.code_client})` : '';
                    return {
                        value: det.id,
                        label: det.raison_sociale + cc + ' - ' + det.ville + ' / '+ det.code_postal
                    }
                });

                this.detenteursFiltred = this.detenteursOpt.slice(0, 20);
                this.onSearch('', false)

            },

            async fetchDetecteur() {

                Outil
                    .getDetecteurActif()
                    .then(data => {
                        this.detecteur = data.id
                    })
                    .catch(() => {
                        swal('Aucun détecteur de fuite', "Vous n'avez pas renseigné votre détecteur de fuites", 'warning')
                    })

            },

            onSearch(str) {
                str = this.normalize(str);

                this.detenteursFiltred = this.detenteursOpt.filter( det =>  {
                    if(this.normalize(det.label).includes(str)) { return det }
                }).slice(0, 20)
            },

            normalize(s) {
                let r = s.toLowerCase();

                r = r.replace(new RegExp(/\s/g),"");
                r = r.replace(new RegExp(/[àáâãäå]/g),"a");
                r = r.replace(new RegExp(/æ/g),"ae");
                r = r.replace(new RegExp(/ç/g),"c");
                r = r.replace(new RegExp(/[èéêë]/g),"e");
                r = r.replace(new RegExp(/[ìíîï]/g),"i");
                r = r.replace(new RegExp(/ñ/g),"n");
                r = r.replace(new RegExp(/[òóôõö]/g),"o");
                r = r.replace(new RegExp(/œ/g),"oe");
                r = r.replace(new RegExp(/[ùúûü]/g),"u");
                r = r.replace(new RegExp(/[ýÿ]/g),"y");
                r = r.replace(new RegExp(/\W/g),"");

                return r;
            },

            async loadInstall(det) {

                let btnScanOtag = document.querySelector('.installations .btn');
                this.installSelected = [];

                if(det === null){
                    this.detenteurSelected = null;
                    this.installations = []
                    btnScanOtag.classList.add('hide');
                } else {
                    this.detenteurSelected = det.value;
                    let installsDet = await Installation.getInstallationsForDet(det.value);

                    let localStorageCtrlMulti = localStorage.getItem(this.localStorage);
                    let localStorageCtrlMultiObj = JSON.parse(localStorageCtrlMulti);

                    if(localStorageCtrlMultiObj['detenteurSelected'] != det.value) {
                        localStorage.removeItem(this.localStorage);
                        this.resetValues();
                        localStorage.setItem('listCtrlMulti', JSON.stringify({}));
                        this.updateLocalStorage('detenteurSelected', det.value);
                        this.checkInstallationWithLocalStorage();

                    }


                    this.installations = installsDet.filter( i => {
                        if( _.has(i, 'fluide') && ! _.isEmpty(i.fluide) ){
                            var typeFluide = i.fluide.type;
                            if(typeFluide === 'HFC' || typeFluide === 'HCFC' || typeFluide === 'CFC' || typeFluide === 'Mélange HFO/HFC' || typeFluide === 'HFO'){
                                return i
                            }
                        }
                    })

                    this.cleanChampDetenteur(det);
                    btnScanOtag.classList.remove('hide');
                }

            },

            checkInstall(val){
                let install = _.find(this.installations, i => i.id == val.target.value);

                if(val.target.checked === true){
                    this.installSelected.push(install)
                } else {
                    _.remove(this.installSelected, i => i.id == val.target.value)
                }

                this.updateLocalStorage('installSelected', this.installSelected);

                this.noFuite = false;
                this.nomSignataire = '';
                this.fonctionSignataire = '';
                this.signatureSignataire = '';

                if(this.installSelected.length > 19){
                    this.locked = true;
                }else{
                    this.locked = false;
                }

            },

            updateSignature(data) {
                this.signatureSignataire = data;
                this.preSendForm();
            }

        },

        mounted() {

            this.fetchDetenteurs();
            this.fetchDetecteur();

            if(localStorage.hasOwnProperty('listCtrlMulti')) {
                this.updatePage()
            }else{
                localStorage.setItem('listCtrlMulti', JSON.stringify({}));
            }

            window.getInstallation = this.getInstallation;

        },

        components: {
            SignatureModal,
            vSelect
        }

    }

</script>



// WEBPACK FOOTER //
// MultiCtrlEtanch.vue?0d746dea